import axios from '../axiosFlotex'

export default {
  getAllList() {
    return axios.get(
      'packages?pagination=false&order[isPublic]=DESC&order[position]=ASC'
    )
  },
  get() {
    return axios.get('packages')
  }
}
